<template>
  <div
    class="cursor-pointer"
    @click="onClick"
    :style="`height: ${height};width: ${width};border-radius:${borderRadius}`"
  >
    <q-card
      flat
      v-ripple
      :style="`height: ${height};width: ${width};border-radius:${borderRadius};background-color: transparent`"
    >
      <slot>Title</slot>
    </q-card>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "77px",
    },
    height: {
      type: String,
      default: "26px",
    },
    borderRadius: {
      type: String,
      default: "2px",
    },
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
